import React,{Component} from 'react';
import connect from "react-redux/es/connect/connect";
import Select from "react-select";
import * as wActs from "../../actions/website-actions";
import DropZone from "react-dropzone";
import * as adActs from "../../actions/advertise-actions";
import ProfileSelectBox from "../profileselectbox";
class AdStepTwo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showingImg: false,
      img: null,
      imgName: "",
      imgWidth: "0px",
      imgHeight: "0px",
      upDisabled: true,
    };
    this.file = null;
  }

  componentDidMount() {
    //this.Url.focus();
  }

  getTranslation(key)
  {
    let tStr = "";
    tStr =  this.props.WebPage.Translations[key];
    if(wActs.isNullOrUndefined(tStr)) { tStr = "" }
    return tStr;
  }

  handleProfileChange(sel) {
    this.setState({url: sel.url});
    this.Url.value = sel.url;
    this.props.dispatch(adActs.GetAdUrlInfo(sel.url));
  }
  handleUrlChange(e) {
    let val = e.target.value;
    if(typeof this.props.handleUrlChange === "function") {
      this.props.handleUrlChange(e,val);
    }
    if(val.startsWith("http://") || val.startsWith("https://")) {
      if(this.iFramely) {this.iFramely.innerHTML = "";}
      this.props.dispatch(adActs.GetAdUrlInfo(val));
    }
  }
  handleTitleChange(e) {
    let val = e.target.value;
    this.setState({title: val});
  }
  handleFile(files) {
    if(!files[0]) {
      return;
    }
    this.setState({showingImg: true, imgName: files[0].name});
    this.file = files[0];
    let fR = new FileReader();
    fR.onload = (res) => {
      let img = new Image();
      let w=0; let h=0;
      let self = this;
      img.onload = function () {
        w = this.width; h = this.height;
        let s = self.props.size;
        let aWidth = s == "Profile" ? 200 : s.split("x")[0];
        let aHeight = s == "Profile" ? 200 : s.split("x")[1];
        let upDis = true;
        if ((aWidth == w && aHeight == h) || s === "Profile") { upDis = false; }
        self.setState({ img: res.target.result, imgWidth: this.width, imgHeight: this.height, upDisabled: upDis });
      };
      img.src = res.target.result;
    };
    fR.readAsDataURL(files[0]);
  }
  handleGoBack(e) {
    e.preventDefault();
    this.props.handleGoBack(e);
  }
  handleUpload(e) {
    e.preventDefault();
    if(this.state.upDisabled) {
      this.props.dispatch(wActs.showWarning("WARN",this.getTranslation("response.invalidimageshouldbegifpngorjpgandxsize").replace("{{size}}",this.props.size)));
      return;
    }
    if(wActs.isNullOrEmpty(this.Title.value)) {
      this.props.dispatch(wActs.showWarning("WARN",this.getTranslation("response.invalidtitle")));
      return;
    }
    if(!this.Url.value.startsWith("http://") && !this.Url.value.startsWith("https://")) {
      this.props.dispatch(wActs.showWarning("WARN",this.getTranslation("response.invalidurl")));
      return;
    }
    let dta = {
      url: this.Url.value, title: this.Title.value
    };
    if(!wActs.isNullOrUndefined(this.state.imageUrl)) {
      dta.imageUrl = this.state.imageUrl
    } else {
      dta.file = this.file;
    }
    this.props.handleUpload(e,dta);
  }



  render() {
    let defTitle = "";
    let txtStyle = {border: "solid 1px #ccc"};
    let ccNme = "";
    let adUrl = this.props.Ads.AdUrl;
    if(adUrl.Loaded && adUrl.Result.Code == 200) {
      try {
        defTitle = adUrl.Result.Result.Title.trim();
      } catch(ex) {}
    }

    if(!wActs.isNullOrUndefined(this.props.country)) {
      this.props.Ads.AdCountries.Result.map((v) => {
        if(v.Code === this.props.country) {
          ccNme = v.Name;
        }
      });
    }

    let aWidth = this.props.size == "Profile" ? "200" : this.props.size.split("x")[0];
    let aHeight = this.props.size == "Profile" ? "200" : this.props.size.split("x")[1];
    let isValid = false;
    if(this.state.showingImg) {
      if((aWidth == this.state.imgWidth && aHeight == this.state.imgHeight) || this.props.size == "Profile") {
        isValid = true;
      }
    }
    let vStyle={fontSize: "15px"};

    return (
      <React.Fragment>

        <div className="sep"></div>

        <div className="cell x4" style={{minHeight: "120px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.advertisementcountry")}</label>
          {ccNme}
        </div>
        <div className="cell x4" style={{minHeight: "120px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.advertisementsize")}</label>
          {this.props.size}
        </div>
        <div className="cell x4" style={{minHeight: "120px"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.startdate")}</label>
          {this.props.startDate}
        </div>

        <div className="half left" style={{minHeight: "120px", display: this.props.size != "Profile" ? "block" : "none"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.targeturl")}</label>
          <input ref={(ref)=>{this.Url=ref}} type="text" onBlur={(e) => {this.handleUrlChange(e)}} defaultValue={this.props.Url} placeholder="https://www.yourdomain.com" style={txtStyle}/>
        </div>
        <div className="half right" style={{minHeight: "120px", display: this.props.size != "Profile" ? "block" : "none"}}>
          <label htmlFor="">{this.getTranslation("page.advertise.title")}</label>
          <input ref={(ref)=>{this.Title=ref}} type="text" onBlur={(e) => {this.handleTitleChange(e)}} defaultValue={defTitle} style={txtStyle}/>
        </div>
        {(this.props.isAgent && this.props.size == "Profile") &&
          <div className="half left" style={{minHeight: "120px"}}>
            <label htmlFor="">{this.getTranslation("page.advertise.selectprofile")}</label>
            <ProfileSelectBox style={wActs.customStyles} placeholder={this.getTranslation("page.advertise.selectorstarttyping")} onChange={(sel) => {this.handleProfileChange(sel)}}/>
            <div className="note">
              <p>{this.getTranslation("page.advertise.chooseoneofyourmodelstext")}</p>
            </div>
          </div>
        }
        <div className="clear"></div>

        {this.props.Ads.AdUrl.Loaded &&
        <React.Fragment>
          {!wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result) && !wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result.Result) && !wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result.Result.Html) &&
            <div className="ad-greybox" ref={(ref) => {this.iFramely = ref}}></div>
          }
        </React.Fragment>
        }


        {this.props.Ads.AdUrl.Loading &&
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>
        }

        {this.props.showUpload &&
        <React.Fragment>
          <div className="ad-greybox" style={{lineHeight: "15px", fontSize: "15px"}}>
            {this.getTranslation("page.advertise.clicktheuploadicontext").replace("{{size}}",this.props.size)}
          </div>


          <div className="sep"></div>
          <div className="clear"></div>

          <div className="ad-uploadarea">
            <DropZone onDrop={(files) => {
              this.handleFile(files)
            }}>
              {({getRootProps, getInputProps}) => (
                <div className="ad-upload" {...getRootProps()}>
                  <input type="file" style={{display: "none"}} {...getInputProps()}
                         accept=".gif,.jpg,.png,.jpeg"/>
                  <div className="ad-upload-text">
                    <i className="fa fa-upload"></i><br/><span>{this.getTranslation("dash.dragfileorclickheretoupload")}</span>
                  </div>
                </div>
              )}
            </DropZone>
          </div>
          <div className="ad-preview">
            {!this.state.showingImg &&
            <div className={"banner-200x200"}>

            </div>
            }
            {this.state.showingImg &&
            <div className={"banner-200x200"}>
              <img src={this.state.img} ref={(ref) => {
                this.Img = ref
              }} alt={"Uploaded image"} style={{maxWidth: "200px", maxHeight: "200px"}}/>
            </div>
            }
          </div>
          {this.state.showingImg &&
          <React.Fragment>
            {!isValid &&
            <div className={"ad-imginfo"} style={{color: "#721c24", fontSize: "15px", background: "#f8d7da"}}>{this.getTranslation("response.invalidimageshouldbegifpngorjpgandxsize").replace("{{size}}",this.props.size)}</div>
            }
          </React.Fragment>
          }

          <div className="clear"></div>
          <div className="buttons centered-content m-t-l">
            <a href="#" style={{padding: "25px 35px", width: "45%", fontSize: "23px"}} className="multistep-btn default-btn" onClick={(evt) => {this.handleGoBack(evt)}}>{this.getTranslation("page.profile.previous")}</a>&nbsp;&nbsp;
            <a href="#" style={{padding: "25px 35px", width: "45%", fontSize: "23px"}} onClick={(evt) => {this.handleUpload(evt)}} className="multistep-btn default-btn">{this.getTranslation("page.profile.next")}</a>
          </div>
        </React.Fragment>
        }
        <div className="clear"></div>
        {!this.props.showUpload &&
          <div className="buttons centered-content m-t-l">
            <a href="#" style={{padding: "25px 35px", width: "45%", fontSize: "23px"}} className="multistep-btn default-btn" onClick={(evt) => {this.handleGoBack(evt)}}>{this.getTranslation("page.profile.previous")}</a>&nbsp;&nbsp;
            <a href="#" style={{padding: "25px 35px", width: "45%", fontSize: "23px"}} onClick={(evt) => {
              let dta = {
                url: this.Url.value, title: this.Title.value
              };
              this.props.handleContinueToBilling(evt,dta);
            }} className="multistep-btn default-btn">{this.getTranslation("page.profile.next")}</a>
          </div>
        }

        <div className={`cell x12`} style={{marginTop: "20px"}}>
          <div className="ad-greybox" style={{textAlign: "left", lineHeight: "15px", fontSize: "15px"}} dangerouslySetInnerHTML={{__html: this.getTranslation("page.advertise.networkofsitesheader")}}></div>
        </div>

        <div className="clear"></div>

      </React.Fragment>
    );
  }
  componentDidUpdate() {
    let adUrl = this.props.Ads.AdUrl;
    if (this.iFramely && !this.iFramely.hasChildNodes()) {
      if (adUrl.Loaded && adUrl.Result.Code == 200 && adUrl.Result.Result.Html) {
        const range = document.createRange();
        this.iFramely.appendChild(range.createContextualFragment(adUrl.Result.Result.Html));
      }
    }
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Ads: state.Ads,
  };
};

export default connect(mapStateToProps)(AdStepTwo);




